var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundShadowOverlayBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_773_1457)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9961,
    y: 0.0727539,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint0_linear_773_1457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9993 42.0723C51.8102 42.073 51.6247 42.0199 51.4645 41.9194C51.3043 41.8188 51.1759 41.6748 51.0943 41.5042C51.0126 41.3336 50.981 41.1433 51.0032 40.9554C51.0254 40.7676 51.1005 40.5899 51.2197 40.443L61.1155 30.2472C61.1898 30.1616 61.2909 30.1037 61.4024 30.083C61.5139 30.0624 61.629 30.0803 61.729 30.1338C61.829 30.1873 61.9078 30.2731 61.9525 30.3773C61.9972 30.4815 62.0052 30.5977 61.9752 30.707L60.056 36.7245C59.9994 36.876 59.9804 37.0389 60.0006 37.1993C60.0208 37.3598 60.0796 37.5129 60.172 37.6456C60.2644 37.7783 60.3876 37.8866 60.5311 37.9612C60.6745 38.0358 60.8339 38.0745 60.9956 38.074H67.9927C68.1818 38.0733 68.3673 38.1264 68.5275 38.2269C68.6877 38.3275 68.8161 38.4715 68.8977 38.6421C68.9794 38.8127 69.0109 39.003 68.9887 39.1909C68.9666 39.3787 68.8915 39.5564 68.7723 39.7033L58.8765 49.899C58.8022 49.9847 58.7011 50.0426 58.5896 50.0632C58.4781 50.0839 58.363 50.066 58.263 50.0125C58.163 49.959 58.0842 49.8732 58.0395 49.769C57.9947 49.6648 57.9868 49.5485 58.0168 49.4392L59.936 43.4217C59.9926 43.2703 60.0116 43.1074 59.9914 42.9469C59.9712 42.7865 59.9124 42.6334 59.82 42.5007C59.7276 42.368 59.6044 42.2597 59.4609 42.1851C59.3175 42.1105 59.1581 42.0718 58.9964 42.0723H51.9993Z",
    stroke: "#F8F8F8",
    strokeWidth: 2.30917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_773_1457",
    x: -4.00391,
    y: -23.9272,
    width: 128,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_773_1457"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_773_1457"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_773_1457"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_773_1457",
    result: "effect2_dropShadow_773_1457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_773_1457",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_1457",
    x1: 19.9961,
    y1: 0.0727539,
    x2: 99.9961,
    y2: 80.0728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundShadowOverlayBlur);
export default __webpack_public_path__ + "static/media/Background+Shadow+OverlayBlur.1685dea5bc23a4459ccd1cfedcdf682a.svg";
export { ForwardRef as ReactComponent };